import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { AuthContext } from "../../context/auth-context";
import { canManagePortfolio } from "../../util/roles";
import "./NavLinks.css";

const NavLinks = (props) => {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const handleLogout = () => {
    auth.logout();
    navigate("/");
  };

  return (
    <ul className="nav-links">
      {!auth.isLoggedIn && (
        <li>
          <NavLink to="/auth">LOGIN</NavLink>
        </li>
      )}
      {auth.isLoggedIn && (
        <>
          <li>
            <NavLink to="/">HOME</NavLink>
          </li>
          <li>
            <NavLink to="/live">LIVE FUND</NavLink>
          </li>
          {canManagePortfolio(auth.role) && (
            <>
              <li>
                <NavLink to="/portfolio">PORTFOLIO</NavLink>
              </li>
              <li>
                <NavLink to="/reports">REPORTS</NavLink>
              </li>
              <li>
                <NavLink to="/newinstrument">ADD INSTRUMENT</NavLink>
              </li>
            </>
          )}
          {auth.role === "admin" && (
            <li>
              <NavLink to="/admin/users">ADMIN</NavLink>
            </li>
          )}
          <li>
            <NavLink to="/usersettings">ACCOUNT</NavLink>
          </li>
          <li>
            <button onClick={handleLogout}>LOG OUT</button>
          </li>
        </>
      )}
    </ul>
  );
};

export default NavLinks;
